import {
  NETWORK_FEED_TYPE,
  GROUP_FEED_TYPE,
  MY_GROUPS_FEED_TYPE,
} from '../constants/FeedType';

export const getAmplitudeConfig = ({
  liveFeedType,
  myGroupsFeedIsEnabled,
}) => ({
  liveFeedVersion: 'V2',
  liveFeedType: mapLiveFeedConfigToAmplitude(liveFeedType),
  myGroupsFeedIsEnabled,
});

export const mapLiveFeedConfigToAmplitude = (liveFeedType) => {
  switch (liveFeedType) {
    case MY_GROUPS_FEED_TYPE:
      return 'myGroupsFeed';
    case GROUP_FEED_TYPE:
      return 'group';
    case NETWORK_FEED_TYPE:
    default:
      return 'network';
  }
};
